module.exports = __webpack_public_path__ + "img/G1.de72999d.png";